export default "__VITE_ASSET__22QvhIjT__"